export default "__VITE_PUBLIC_ASSET__3e587042__"